// extracted by mini-css-extract-plugin
module.exports = {"garellyFavotite":"styles_garellyFavotite__RjMk4","imgs":"styles_imgs__1OzC1","favorite":"styles_favorite__1W0z_"};